import React from 'react';

import FeatureFlag from '@src/components/FeatureFlag';
import CheckoutLegacy, { CheckoutProps } from '@src/components/Checkout/CheckoutLegacy';
import { CheckoutShellSkeleton, CheckoutWidget } from '@src/views/checkout';

const Checkout = (props: CheckoutProps) => {
  return (
    <FeatureFlag
      feature='PR-3043-checkout'
      pending={() => <CheckoutShellSkeleton />}
      active={() => <CheckoutWidget {...props} />}
      fallback={() => <CheckoutLegacy {...props} />}
    />
  );
};

export type { CheckoutProps };
export default Checkout;
